import {applySnapshot, destroy, getSnapshot, Instance, types} from "mobx-state-tree";
import {Image, ImageDefaultStore} from './models'

const LandingPageStore = types
    .model({
        tagline: types.string,
        logo: types.maybeNull(Image),
        backgroundColor: types.string,
        backgroundImage: types.maybeNull(Image),
        textColor: types.string,
    })
    .views(self => ({
        get canProceed(): boolean {
            if (!self.backgroundColor)
                return false;
            if (self.logo && !self.logo.isLoaded)
                return false;
            if (self.backgroundImage && !self.backgroundImage.isLoaded)
                return false;
            return !!(self.tagline || self.logo || self.backgroundImage || self.backgroundColor);
        },
        get imagesAreValid() {
            if (self.logo && !self.logo.isUploaded) {
                return false
            }
            return !(self.backgroundImage && !self.backgroundImage.isUploaded);
        },
    }))
    .actions(self => {
        let initialState = {};
        return {
            afterCreate() {
                initialState = getSnapshot(self);
            },
            reset: () => {
                applySnapshot(self, initialState);
            },
            reUploadAll: function () {
                self.logo && self.logo.reupload();
                self.backgroundImage && self.backgroundImage.reupload();
            },
            removeLogo() {
                if (self.logo) {
                    destroy(self.logo)
                }
                self.logo = null;
            },
            removeBackgroundImage() {
                if (self.backgroundImage) {
                    destroy(self.backgroundImage)
                }
                self.backgroundImage = null;
            },
            setTagline: function (value: string) {
                self.tagline = value;
            },
            setTextColor: function (value: string) {
                self.textColor = value
            },
            setBackgroundColor: function (value: string) {
                self.backgroundColor = value
            },
            setURLLogo: function (value: string) {
                if (self.logo) {
                    destroy(self.logo)
                }
                self.logo = Image.create({...ImageDefaultStore, path: value, isLocalImage: false});
                self.logo.upload();
            },
            setLocalLogo: function (file: File) {
                if (self.logo) {
                    destroy(self.logo)
                }
                self.logo = Image.create({...ImageDefaultStore, path: URL.createObjectURL(file), isLocalImage: true});
                self.logo.setFile(file);
                self.logo.upload();
            },
            setURLBackgroundImage: function (value: string) {
                if (self.backgroundImage) {
                    destroy(self.backgroundImage)
                }
                self.backgroundImage = Image.create({...ImageDefaultStore, path: value, isLocalImage: false});
                self.backgroundImage.upload();
            },
            setLocalBackgroundImage: function (file: File) {
                if (self.backgroundImage) {
                    destroy(self.backgroundImage)
                }
                self.backgroundImage = Image.create({
                    ...ImageDefaultStore,
                    path: URL.createObjectURL(file),
                    isLocalImage: true
                });
                self.backgroundImage.setFile(file);
                self.backgroundImage.upload();
            },

        }
    });


export interface ILandingPageStore extends Instance<typeof LandingPageStore> {
}

export const LandingPageDefaultStore = {tagline: '', backgroundColor: '', textColor: ''};

export default LandingPageStore;
